import { useFormContext } from 'react-hook-form';
import { Select, Text } from 'theme-ui';
import { Stack } from '@bedrock-layout/stack';
import React from 'react';
import { arrayOf, shape, string } from 'prop-types';

const SelectField = ({ label, name, options }) => {
  const { register, formState, getValues } = useFormContext();
  const error = _.get(formState.errors, name);
  const errorMsg = error && error.message;

  return (
    <>
      <Stack gutter="lg">
        <Text variant="label">{label}</Text>
        <Select {...register(name)} defaultValue={getValues(name)}>
          {options.map((option) => (
            <option name={option.label} key={option.label} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
        {error && error.message && errorMsg.length > 0 && <Text color={errorMsg ? 'errorText' : null}>{errorMsg}</Text>}
      </Stack>
    </>
  );
};

SelectField.propTypes = {
  label: string,
  name: string,
  options: arrayOf(
    shape({
      value: string,
      label: string,
    })
  ),
};

export default SelectField;
